// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-app-section-wrapper-psp {
  width: 100%;
  max-width: 1440px;
  height: 430px;
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-top: 60px;
}
.mobile-app-section-wrapper-psp .mobile-app-right-section-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
  background-color: #F0F5FF;
  width: 100%;
  height: 100%;
  margin-left: -28px;
  padding: 40px;
  padding-left: 80px;
}
.mobile-app-section-wrapper-psp .mobile-app-right-section-wrapper span:first-child {
  font-size: 28px;
  font-weight: 700;
  text-align: left;
}
.mobile-app-section-wrapper-psp .mobile-app-right-section-wrapper span:nth-child(2) {
  font-size: 16px;
  font-weight: 500;
  text-align: left;
}
.mobile-app-section-wrapper-psp .mobile-app-right-section-wrapper .mobile-number-input-wrapper {
  margin-top: 10px;
}
.mobile-app-section-wrapper-psp .mobile-app-right-section-wrapper .mobile-number-input-wrapper input {
  min-width: 300px;
  padding: 14px 16px;
  border: 1px solid #ddd;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-right: none;
}
.mobile-app-section-wrapper-psp .mobile-app-right-section-wrapper .mobile-number-input-wrapper input ::placeholder {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5019607843);
}
.mobile-app-section-wrapper-psp .mobile-app-right-section-wrapper .mobile-number-input-wrapper input:focus-within {
  outline: none;
}
.mobile-app-section-wrapper-psp .mobile-app-right-section-wrapper .mobile-number-input-wrapper button {
  min-width: 120px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #93288E;
  color: #fff;
  padding: 14px 0;
}
.mobile-app-section-wrapper-psp .mobile-app-right-section-wrapper .mobile-app-store-btn-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
}

.small-mobile-app-section-wrapper-psp {
  display: none;
}

@media only screen and (1024px <= width <= 1260px) {
  .mobile-app-section-wrapper-psp {
    margin-top: 30px;
    height: 350px;
  }
  .mobile-app-section-wrapper-psp > img {
    width: 510px;
  }
  .mobile-app-section-wrapper-psp .mobile-app-right-section-wrapper {
    padding: 24px;
  }
}
@media only screen and (width < 1024px) {
  .mobile-app-section-wrapper-psp {
    display: none;
  }
  .small-mobile-app-section-wrapper-psp {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    background-color: #F0F5FF;
    width: 100%;
    padding: 20px;
    margin-top: 30%;
  }
  .small-mobile-app-section-wrapper-psp .image-wrapper {
    margin-top: -35%;
  }
  .small-mobile-app-section-wrapper-psp > span:nth-child(2) {
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }
  .small-mobile-app-section-wrapper-psp > span:nth-child(3) {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }
  .small-mobile-app-section-wrapper-psp .mobile-number-input-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .small-mobile-app-section-wrapper-psp .mobile-number-input-wrapper input {
    width: 70%;
    max-width: 300px;
    padding: 14px 16px;
    border: 1px solid #ddd;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-right: none;
  }
  .small-mobile-app-section-wrapper-psp .mobile-number-input-wrapper input ::placeholder {
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.5019607843);
  }
  .small-mobile-app-section-wrapper-psp .mobile-number-input-wrapper input:focus-within {
    outline: none;
  }
  .small-mobile-app-section-wrapper-psp .mobile-number-input-wrapper button {
    width: 30%;
    max-width: 140px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: #93288E;
    color: #fff;
    padding: 14px 0;
  }
  .small-mobile-app-section-wrapper-psp .mobile-app-store-btn-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PaymentStatusPage/components/MobileAppSectionPSP/style.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AACR;AAAQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAEZ;AAAQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAEZ;AACQ;EACI,gBAAA;AACZ;AAAY;EACI,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;AAEhB;AADgB;EACI,eAAA;EACA,gBAAA;EACA,kCAAA;AAGpB;AADgB;EACI,aAAA;AAGpB;AACY;EACI,gBAAA;EACA,4BAAA;EACA,+BAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AAChB;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AADZ;;AAMA;EACI,aAAA;AAHJ;;AAMA;EACI;IACI,gBAAA;IACA,aAAA;EAHN;EAIM;IACI,YAAA;EAFV;EAKM;IACI,aAAA;EAHV;AACF;AAOA;EACI;IACI,aAAA;EALN;EAQE;IACI,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,yBAAA;IACA,WAAA;IACA,aAAA;IACA,eAAA;EANN;EAOM;IACI,gBAAA;EALV;EAOM;IACI,eAAA;IACA,gBAAA;IACA,kBAAA;EALV;EAOM;IACI,eAAA;IACA,gBAAA;IACA,kBAAA;EALV;EAQM;IACI,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EANV;EAOU;IACI,UAAA;IACA,gBAAA;IACA,kBAAA;IACA,sBAAA;IACA,2BAAA;IACA,8BAAA;IACA,kBAAA;EALd;EAMc;IACI,eAAA;IACA,gBAAA;IACA,kCAAA;EAJlB;EAMc;IACI,aAAA;EAJlB;EAQU;IACI,UAAA;IACA,gBAAA;IACA,4BAAA;IACA,+BAAA;IACA,yBAAA;IACA,WAAA;IACA,eAAA;EANd;EAUM;IACI,aAAA;IACA,mBAAA;IACA,SAAA;IACA,eAAA;EARV;AACF","sourcesContent":[".mobile-app-section-wrapper-psp{\n    width: 100%;\n    max-width: 1440px;\n    height: 430px;\n    display: flex;\n    align-items: center;\n    margin-right: 20px;\n    margin-top: 60px;\n\n    .mobile-app-right-section-wrapper{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        gap: 14px;\n        background-color: #F0F5FF;\n        width: 100%;\n        height: 100%;\n        margin-left: -28px;\n        padding: 40px;\n        padding-left: 80px;\n        span:first-child{\n            font-size: 28px;\n            font-weight: 700;\n            text-align: left;\n        }\n        span:nth-child(2) {\n            font-size: 16px;\n            font-weight: 500;\n            text-align: left;\n        }\n\n        .mobile-number-input-wrapper{\n            margin-top: 10px;\n            input{\n                min-width: 300px;\n                padding: 14px 16px;\n                border: 1px solid #ddd;\n                border-top-left-radius: 4px;\n                border-bottom-left-radius: 4px;\n                border-right: none;\n                ::placeholder{\n                    font-size: 14px;\n                    font-weight: 500;\n                    color: #00000080;\n                }\n                &:focus-within{\n                    outline: none;\n                }\n            }\n\n            button{\n                min-width: 120px;\n                border-top-right-radius: 4px;\n                border-bottom-right-radius: 4px;\n                background-color: #93288E;\n                color: #fff;\n                padding: 14px 0;\n            }\n        }\n\n        .mobile-app-store-btn-wrapper{\n            display: flex;\n            align-items: center;\n            gap: 16px;\n            margin-top: 8px;\n        }\n    }\n}\n\n.small-mobile-app-section-wrapper-psp{\n    display: none;\n}\n\n@media only screen and (1024px <= width <= 1260px) {\n    .mobile-app-section-wrapper-psp{\n        margin-top: 30px;\n        height: 350px;\n        >img{\n            width: 510px;\n        }\n\n        .mobile-app-right-section-wrapper{\n            padding: 24px;\n        }\n    }\n}\n\n@media only screen and (width < 1024px) {\n    .mobile-app-section-wrapper-psp{\n        display: none;\n    }\n\n    .small-mobile-app-section-wrapper-psp{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 14px;\n        background-color: #F0F5FF;\n        width: 100%;\n        padding: 20px;\n        margin-top: 30%;\n        .image-wrapper{\n            margin-top: -35%;\n        }\n        >span:nth-child(2){\n            font-size: 28px;\n            font-weight: 700;\n            text-align: center;\n        }\n        >span:nth-child(3) {\n            font-size: 16px;\n            font-weight: 500;\n            text-align: center;\n        }\n\n        .mobile-number-input-wrapper{\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            input{\n                width: 70%;\n                max-width: 300px;\n                padding: 14px 16px;\n                border: 1px solid #ddd;\n                border-top-left-radius: 4px;\n                border-bottom-left-radius: 4px;\n                border-right: none;\n                ::placeholder{\n                    font-size: 14px;\n                    font-weight: 500;\n                    color: #00000080;\n                }\n                &:focus-within{\n                    outline: none;\n                }\n            }\n\n            button{\n                width: 30%;\n                max-width: 140px;\n                border-top-right-radius: 4px;\n                border-bottom-right-radius: 4px;\n                background-color: #93288E;\n                color: #fff;\n                padding: 14px 0;\n            }\n        }\n\n        .mobile-app-store-btn-wrapper{\n            display: flex;\n            align-items: center;\n            gap: 16px;\n            margin-top: 8px;\n        }\n    }    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
